// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
var decodeRecord1 = /* #__PURE__ */ Unscramble.decodeRecord1();
var startIsSymbol = {
    reflectSymbol: function () {
        return "start";
    }
};
var stopIsSymbol = {
    reflectSymbol: function () {
        return "stop";
    }
};
var daysIsSymbol = {
    reflectSymbol: function () {
        return "days";
    }
};
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var eqRec = /* #__PURE__ */ Data_Eq.eqRec();
var eqRowCons = /* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)();
var recordEncode = /* #__PURE__ */ Foreign_Generic_Class.recordEncode();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil);
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode);
var recordDecode = /* #__PURE__ */ Foreign_Generic_Class.recordDecode();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeRecordCons1 = /* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil);
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode);
var TimeRange = function (x) {
    return x;
};
var OpeningHours = function (x) {
    return x;
};
var udecodeTimeRange = /* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(startIsSymbol)(Unscramble.decodeInt1)(/* #__PURE__ */ Unscramble.decodeRecordCons(stopIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordNil)));
var udecodeOpeningHours = /* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(daysIsSymbol)(/* #__PURE__ */ Unscramble.decodeArray1(udecodeTimeRange))(Unscramble.decodeRecordNil));
var showTimeRange = /* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(startIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(stopIsSymbol)(Data_Show.showInt))(Data_Show.showInt));
var showOpeningHours = /* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(daysIsSymbol)(/* #__PURE__ */ Data_Show.showArray(showTimeRange)));
var newtypeTimeRange = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeOpeningHours = {
    Coercible0: function () {
        return undefined;
    }
};
var eqTimeRange = /* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons(stopIsSymbol)(Data_Eq.eqInt))()(startIsSymbol)(Data_Eq.eqInt));
var eqOpeningHours = /* #__PURE__ */ eqRec(/* #__PURE__ */ eqRowCons(daysIsSymbol)(/* #__PURE__ */ Data_Eq.eqArray(eqTimeRange)));
var encodeTimeRange = /* #__PURE__ */ recordEncode(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(stopIsSymbol)(encodeWithOptionsOther))(startIsSymbol)(encodeWithOptionsOther));
var encodeOpeningHours = /* #__PURE__ */ recordEncode(/* #__PURE__ */ encodeRecordCons1(daysIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeTimeRange))));
var decodeTimeRange = /* #__PURE__ */ recordDecode(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons1(stopIsSymbol)(decodeWithOptionsOther)())(startIsSymbol)(decodeWithOptionsOther)());
var decodeOpeningHours = /* #__PURE__ */ recordDecode(/* #__PURE__ */ decodeRecordCons1(daysIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeTimeRange)))());
export {
    OpeningHours,
    TimeRange,
    newtypeOpeningHours,
    showOpeningHours,
    eqOpeningHours,
    decodeOpeningHours,
    udecodeOpeningHours,
    encodeOpeningHours,
    newtypeTimeRange,
    showTimeRange,
    eqTimeRange,
    decodeTimeRange,
    udecodeTimeRange,
    encodeTimeRange
};
